function emailAddressValidator({ input, msgs }) {
  const rule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!rule.test(input)) {
    return (msgs && msgs.msg) || 'Value must be a well-formed email address.';
  }

  return null;
}

export default emailAddressValidator;
